import { Button, Checkbox } from '@design-system';
import { useTranslation } from 'next-i18next';
import { ReactNode } from 'react';

import { SimpleDialog } from '../../../Dialog/SimpleDialog';

export type AddAddressDialogProps = {
  /** Stripe `AddressElement`, injected by the wrapper. */
  addressFields: ReactNode;
  saveAddress: boolean;
  canSave?: boolean;
  isSaving?: boolean;
  error?: ReactNode;
  onSaveAddressChange: (saveAddress: boolean) => void;
  onSave: () => void;
  onClose: () => void;
};

export const AddAddressDialog = ({
  addressFields,
  canSave = true,
  error,
  isSaving,
  onClose,
  onSave,
  onSaveAddressChange,
  saveAddress,
}: AddAddressDialogProps) => {
  const { t } = useTranslation('checkout');

  return (
    <SimpleDialog
      centered
      onClose={onClose}
      open
      title={t('details.shippingAddress.addTitle')}
    >
      <div className="flex flex-col gap-3">
        {error}

        {addressFields}

        <Checkbox
          checked={saveAddress}
          id="details-dialog-save-address"
          label={t('details.shippingAddress.save')}
          name="details-dialog-save-address"
          onChange={(e) => onSaveAddressChange(e.currentTarget.checked)}
          type="checkbox"
        />

        <Button
          disabled={!canSave || isSaving}
          fullWidth
          label={t('details.save')}
          loading={isSaving}
          onClick={onSave}
          variant="primary"
        />
      </div>
    </SimpleDialog>
  );
};
